import { render, staticRenderFns } from "./archivingRestore.vue?vue&type=template&id=7ceff191&scoped=true&"
import script from "./archivingRestore.vue?vue&type=script&lang=js&"
export * from "./archivingRestore.vue?vue&type=script&lang=js&"
import style0 from "./archivingRestore.vue?vue&type=style&index=0&id=7ceff191&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ceff191",
  null
  
)

export default component.exports